// @flow
import React, { useState, useCallback } from 'react';
import { Grid, GridColumn, GridRow, Checkbox, Button } from 'semantic-ui-react';
import * as css from './PaymentAndTerms.module.css';
import { infoLogger } from '../../helpers';
import Modal from 'components/Modal';
import Card from '../Card';
import { ModalTypes } from '../../Constants';

type PropsType = {
  label?: string,
  content: Object,
  terms: Object,
  onAddSubscription: () => void,
};

const PaymentAndTerms = ({ label, content, terms, onAddSubscription }: PropsType) => {
  const [showTerms, setShowTerms] = useState(false);
  const [consent, setConsent] = useState(false);

  const handleConsentCheckboxChange = useCallback(() => {
    infoLogger({
      name: 'client-handle-consent-checkbox',
      log: !consent ? 'Customer consented' : 'Customer revoked consent',
    });
    setConsent(!consent);
  });

  const closeModalAcceptTerms = useCallback(() => {
    infoLogger({ name: 'client-accept-terms-modal', log: 'Customer consented to terms, via terms modal' });
    setShowTerms(false);
    setConsent(true);
  }, [setConsent]);

  const toggleModalTerms = useCallback(() => {
    infoLogger({ name: 'client-toggle-terms-modal', log: 'Customer closed terms modal' });
    setShowTerms(!showTerms);
  }, [showTerms]);

  return (
    <>
      <Card isComviq={true}>
        <Grid className={css.fullWidth}>
          <GridRow className={css.borderBottom} columns={1}>
            <GridColumn className={css.flex} width={16}>
              {label && <span className={css.label}>{label}</span>}
              <div>
                <div className={css.label}>Betala med faktura</div>
                <div className={css.light}>Du får din faktura på din mail</div>
                {/* <div className={css.light}>karim@comviq.com</div> */}
              </div>
            </GridColumn>
          </GridRow>
          <GridRow className={css.borderBottom} columns={1}>
            <GridColumn className={css.flex} width={16}>
              <Checkbox className={css.checkbox} checked={consent} onChange={handleConsentCheckboxChange} />
              <span className={css.term}>
                <span className={css.bold}>{'Jag godkänner'}</span>
                <span onClick={toggleModalTerms} className={css.toggleLink}>
                  {'gällande allmänna vilkor.'}
                </span>
              </span>
              {showTerms && (
                <Modal
                  isComviq={true}
                  content={terms}
                  handleAccept={closeModalAcceptTerms}
                  handleClose={toggleModalTerms}
                  type={ModalTypes.TERMS}
                />
              )}
              {/* <p className={css.info}>{info}</p> */}
            </GridColumn>
          </GridRow>
          <GridRow columns={1}>
            <GridColumn className={css.flex} width={16}>
              <Button
                color="pink"
                fluid
                className={css.button}
                onClick={onAddSubscription}
                disabled={!consent}
                id="addSubscription"
              >
                {content.button}
              </Button>
            </GridColumn>
          </GridRow>
        </Grid>
      </Card>
    </>
  );
};

export default React.memo(PaymentAndTerms);
